export const INIT_FORM = 'FORM_INIT_FORM'
export const SET_FORM_ERRORS = 'FORM_SET_FORM_ERRORS'
export const SET_FIELD_ERRORS = 'FORM_SET_FIELD_ERRORS'
export const FOCUS_FIELD = 'FORM_FOCUS_FIELD'
export const TOUCH_FIELD = 'FORM_TOUCH_FIELD'
export const UNTOUCH_FIELD = 'FORM_UNTOUCH_FIELD'
export const TOUCH_ALL_FIELDS = 'FORM_TOUCH_ALL_FIELDS'
export const UPDATE_FIELD = 'FORM_UPDATE_FIELD'

// Stepped Form
export const INIT_STEPPED_FORM = 'FORM_INIT_STEPPED_FORM'
export const START_UPDATING = 'START_UPDATING'
export const STOP_UPDATING = 'STOP_UPDATING'
export const GOTO_PREV_STEP = 'GOTO_PREV_STEP'
export const GOTO_NEXT_STEP = 'GOTO_NEXT_STEP'
